export const SELECT_HINT_LEARN_MORE =
  'https://knowledge-base.yieldbird.com/prebid-stack/user-id-sub-modules-list'
